import { AuthProvider } from '../contexts/AuthContext';
import configureAmplify from 'config/amplify-configuration';
import { RouterProvider } from 'react-router';
import router from './routes/router';
import GTMProvider from 'analytics/GTMProvider';

configureAmplify();

const App = () => {
  return (
    <AuthProvider>
      <GTMProvider>
        <RouterProvider router={router} />
      </GTMProvider>
    </AuthProvider>
  );
};

export default App;
